import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 py-12 px-4 border-t border-gray-800" data-id="element-187">
      <div className="max-w-4xl mx-auto text-center" data-id="element-188">
        <div className="text-gray-400 text-sm mb-6 space-y-2" data-id="element-189">
          <p data-id="element-190">© 2025 El Método 500€ | elmetodo500.es</p>
          <div className="flex justify-center gap-4 flex-wrap" data-id="element-191">
            <a href="#" className="hover:text-neon transition-colors" data-id="element-192">
              Política de Privacidad
            </a>
            <span data-id="element-193">|</span>
            <a href="#" className="hover:text-neon transition-colors" data-id="element-194">
              Términos y Condiciones
            </a>
            <span data-id="element-195">|</span>
            <a href="#" className="hover:text-neon transition-colors" data-id="element-196">
              Contacto
            </a>
          </div>
        </div>

        <div className="text-gray-500 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-197">
          <p data-id="element-198">Este producto es material educativo e informativo.</p>
          <p data-id="element-199">
            Los resultados individuales pueden variar según el esfuerzo y las
            condiciones del mercado.
          </p>
          <p data-id="element-200">No se garantizan ingresos específicos.</p>
        </div>
      </div>
    </footer>;
}